'use client';
import { FC, useState } from 'react';
import { Flex, Text, Box } from '@eqi-investimentos/react';
import { Badge, RadioGroup, Radio } from '@chakra-ui/react';
import { useT } from '@/libs/i18n/utils/useT';

export const ProfileSelectRadio: FC<ProfilesProps> = ({ onChange }) => {
  const t = useT();

  const [selectedOption, setSelectedOption] = useState<string>(
    t(`screens.calculadora-viver-de-renda.profiles.profile02.value`)
  );
  const profiles = Array.from({ length: 3 }, (_, i) => {
    const profileKey = `profile0${i + 1}`;
    return {
      risk: t(`screens.calculadora-viver-de-renda.profiles.${profileKey}.risk`),
      title: t(
        `screens.calculadora-viver-de-renda.profiles.${profileKey}.title`
      ),
      value: t(
        `screens.calculadora-viver-de-renda.profiles.${profileKey}.value`
      ),
      description: t(
        `screens.calculadora-viver-de-renda.profiles.${profileKey}.description`
      ),
    };
  });

  const handleChange = (value: string) => {
    setSelectedOption(value);
    onChange(value);
  };

  return (
    <RadioGroup
      colorScheme="orange"
      onChange={handleChange}
      value={selectedOption}
      sx={{
        '&': {
          display: 'flex',
          flexDirection: 'column',
          gap: '0.675rem',
          cursor: 'pointer',
          '> div': {
            _hover: {
              borderColor: 'content.brand',
            },
          },
        },
      }}
    >
      {profiles.map(({ risk, title, description, value }, i) => (
        <Flex
          key={i}
          justifyContent="space-between"
          alignItems="center"
          borderRadius="xs"
          borderWidth="1px"
          borderStyle="solid"
          paddingX={20}
          paddingY={12}
          w="full"
          onClick={() => handleChange(value)}
        >
          <Box>
            <Badge
              fontSize={12}
              borderRadius="2xs"
              paddingX={8}
              mb={4}
              textTransform="none"
              bg="content.brand"
              color="content.inverse"
              fontWeight="medium"
            >
              {risk}
            </Badge>
            <Text size="x" fontWeight={600}>
              {title}
            </Text>
            <Text size="l">{description}</Text>
          </Box>
          <Radio
            key={`radio-option-${risk}-${value}`}
            aria-checked={selectedOption === value}
            value={value}
          />
        </Flex>
      ))}
    </RadioGroup>
  );
};

type ProfilesProps = {
  onChange: (value: string) => void;
};
